import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {WorkingObject} from '@models/working-object';
import {SelectValueInterface} from '@interfaces/select-value.interface';

@Injectable()
export class WorkingObjectsStatusesProvider {
    data$ = new BehaviorSubject<SelectValueInterface[]>(WorkingObject.statuses);
}
